import { render, staticRenderFns } from "./createPremium.vue?vue&type=template&id=5edded39&"
import script from "./createPremium.vue?vue&type=script&lang=js&"
export * from "./createPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports